import { useAppSelector } from "@/hooks";
import { auth } from "@/lib/firebase";
import { currentUser } from "@/store/appSlice";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const RequireAuth = () => {
  const authUser: any = useAppSelector(currentUser);
  const [user, setUser] = useState<any>(authUser);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const tokenResult = await currentUser.getIdTokenResult();
        const claims = tokenResult.claims;
        setUser({ ...currentUser, claims });
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  if (!user) return <Navigate to="/login" />;

  if (!user?.claims?.isAdmin && user?.claims?.isUserManageAdmin && user?.claims?.isContentManageAdmin) {
    if (!(location.pathname === "/users" || location.pathname.includes('/users/') || location.pathname === "/content" || location.pathname === "/update-password")) {
      return <Navigate to="/404" />;
    }
  } else if (!user?.claims?.isAdmin && user?.claims?.isUserManageAdmin && !user?.claims?.isContentManageAdmin && !(location.pathname === "/users" || location.pathname.includes('/users/') || location.pathname === "/update-password")) {
    return <Navigate to="/404" />;
  } else if (!user?.claims?.isAdmin && user?.claims?.isContentManageAdmin && user?.claims?.isUserManageAdmin && !(location.pathname === "/content" || location.pathname === "/update-password")) {
    return <Navigate to="/404" />;
  }

  return <Outlet />
};

export default RequireAuth;
